const TeamList = [

    {

        Avatar: "/boss.png",
        Name: "Hon.  Dr. Uriel Ezeh",
        icon: "fas fa-star",
        Position: "Group Managing Director",
        About: "Hon. Dr. Uriel A. Ezeh (ILM) is the Founder and Group Chief Executive Officer of UR9 GROUP. A multi-talented business tycoon, he has overseen the growth and expansion of the UR9 brand into one of the foremost premium luxury brands in the country.A graduate of Business and Management from the University of Sunderland and a dual Master’s holder of Management and Leadership; Global Management from the prestigious Regent’s Business School, London.The Honourable Doctor Uriel has shown himself to be a serial entrepreneur with the gift of discerning times and seasons; a gift from God he acknowledges as one of the foundations of success of the UR9 Group.",
        member: "Fellow: Institute of Chartered Administrators and Researchers of Nigeria." ,
        button: "Read More"

    },

    {

        Avatar: "/DMD.png",
        Name: "Glory Adeniyi",
        icon: "fas fa-star",
        Position: "Deputy Managing Director(DMD)",
        About: "Miss Glory C. Adeniyi is the Deputy Managing Director of UR9 Group. She is a graduate of Ladoke Akintola University of Technology (LAUTECH). She graduated with a Bachelor of Technology in Agronomy. She worked as a Field Supervisor/Research Assistant at the International Institute of Tropical Agriculture (IITA) before going on to work as an Admin / Human Resource Officer at Leadway Assurance Company. She also worked at the Nigerian National Assembly (NASS) as the Legislative Aide to the Deputy President of the Senate before going on to assume her position at UR9 Group. "  +

          "She gained valuable leadership as well as administrative experience from herbdofferent roles and those experiences as well as her keen eye for detail and ability to see potential business opportunities even before they develop have helped shape her into the business icon she is today."

    },


    {

        Avatar: "/Hr.jpg",
        Name: "Sandra Udeji",
        icon: "fas fa-star",
        Position: "HR/GM",
        About: "Miss Sandra Udeji is a highly experienced and accomplished Human Resource professional and Operations Manager at UR9, holding a degree in Bio-Technology from Godfrey Okoye University. " +
            "A member of chattered Institute of Human Resources management Nigeria and boasting an impressive track record as a Human Resource Assistant at the National Office for Technology Acquisition and Promotion." +
            " With three certifications in Human Resource Management, Human Resource Diploma, and Project Management. Sandra brings a unique blend of strategic insight, operational expertise, and leadership acumen to her role,skillfully " +
            " managing all aspects of Human Resources and overseeing the overall operations of the company with precision and finesse, driving efficiency, productivity, and success at UR9."

    },







    // {

    //     Avatar: "/Abdul.jpg",
    //     Name: "Engr. Abdulmalik- Sheriff Mustapha",
    //     icon: "fas fa-star",
    //     Position: "Head of Construction",
    //     About: "Engr. Abdulmalik Mustafa is the Head of Construction at UR9. He is a graduate of Engineering  from the prestigious Ahmadu Bello University, Zaria. After training as an Aircraft Technician  with the Nigerian College of Aviation Technology (NCAT), he joined the real estate industry as  an Engineer with a handful of real estate companies. Also a certified Project Manager and Programmer, he has worked on several successful projects  spanning across property development and web development before assuming his position at UR9  Group.  He is a charismatic and efficient team leader with a keen eye for detail"

    // },



    {

        Avatar: "/Agnes.jpeg",
        Name: "Shimaor Dowgo Avadoo",
        icon: "fas fa-star",
        Position: "Site Manager and Estate Surveyor",
        About: "Shimaor Dowgo Avadoo, a seasoned real estate professional and licensed estate surveyor with" +
            " a PGD in Facilities Management and Certification in Project Management, in the construction" +
            " division at UR9 Group as site manager driving growth and success through her expertise in" +
            " property valuation, market analysis, project management, and team leadership while overseeing" +
            " strategic planning, project execution, and site operations, and fostering long-term relationships" +
            " with clients, partners, and stakeholders."


    },



    
    // {

    //     Avatar: "/legal.jpg",
    //     Name: " Mary Wamu Kpanja",
    //     icon: "fas fa-star",
    //     Position: "Legal Officer",
    //     About: "Mary Wamu Kpanja, Esq. is the Legal and Compliance Supervisor at UR9 Group, bringing a wealth of legal expertise and a diverse skill set to the table. A graduate of Ahmadu Bello University and the Nigeria Law School (Lagos Campus), she is currently pursuing an LL.M in Intellectual Property Law and Policy. "+
    //     "Mary also holds a professional diploma in social media and a product management certificate from 3MTT. Beyond her corporate role, Mary is the Executive Director of Kpanja Poverty Alleviation Initiative, an NGO dedicated to empowering individuals and communities. " +
    //    "She has spearheaded initiatives to help students in underserved areas return to school. Mary is also a Cohort6 fellow of the SDG Advocate Program under SDSN Youth Nigeria. In her legal  role at UR9 Group,"+
    //     " Mary ensures legal compliance across subsidiaries, upholding high standards and internal policies with precision and dedication."
    // },



    {

        Avatar: "/Anita.jpg",
        Name: " Asemokhai Anita Ochuwa",
        icon: "fas fa-star",
        Position: "Admin/Head of Events",
        About:  "Miss Anita is the Admin/Event Planner at UR9 Group, she is responsible for planning, coordinating, and executing high-profile events, conferences, and weddings. " +
            "With a keen eye for detail and passion for creativity and excellence. She excels in fast-paced environments where values and impact are made."

    },




    {

        Avatar: "/lfhsupervisor.jpg",
        Name: "Miss Anthonia E. Imana",
        icon: "fas fa-star",
        Position: "Fashion Supervisor",
        About: "Miss Anthonia E. Imana is an Insightful and highly experienced and accomplished supervisor in the fashion space, " +
        "worked in various fashion Houses before joining the UR9 group. A supervisor within processing and improving operations through " +
       " effective employee motivational strategies. Proficient in best practices, market trends and regulatory requirements of industry operations. " +
       " With B.sc from the prestigious Ambrose Alli University with a proven track record of leading high performing team and meeting customers needs adequately."
    },





]

export default TeamList;

